<template>
  <div class="college_detail">
    <header v-if="$route.query.isApp">
      <van-icon
        :name="isDirection ? 'arrow' : 'arrow-left'"
        @click.stop="
          $router.push({
            path: $route.query.path,
            query: {
              id: $route.query.categoryid,
              activeid: $route.query.activeid,
              isApp: $route.query.isApp,
              language: $route.query.language
            }
          })
        "
      ></van-icon>
      <i class="icon-fenxiang iconfont" @click.stop="handleShare"></i>
    </header>
    <main>
      <div @touchmove.stop class="commont_body">
        <dl>
          <dt><img v-show="data.imgs" :src="data.imgs" alt="" /></dt>
          <dd>
            <div class="title">
              <b>{{ data.title }}</b>
            </div>
            <div class="release" v-if="!$route.query.istime">
              {{ parsetime(data.releaseTime, "{y}/{m}/{d}") }}
            </div>
          </dd>
          <div class="bottom">
            <div></div>
          </div>
        </dl>
        <div class="content" v-html="data.content"></div>
      </div>
    </main>
  </div>
</template>

<script>
import { Icon, Skeleton } from "vant";
import { getdatadetail } from "@/api/resource";
import { parseTime } from "../../utils";
import { mapGetters } from "vuex";
export default {
  name: "detail",
  components: { vanIcon: Icon },
  data() {
    return {
      data: {}
    };
  },
  computed: {
    ...mapGetters(["isDirection"])
  },
  created() {
    let id = this.$route.query.id;
    getdatadetail({ id: id }).then(res => {
      this.data = res.data;
    });
  },
  methods: {
    parsetime(data, cFormat) {
      return parseTime(data, cFormat);
    },
    handleShare() {
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appSharing,
        {
          code: 200,
          img: this.data.imgs,
          title: this.data.title,
          url: window.location.href.slice(
            0,
            window.location.href.indexOf("activeid")
          ),
          text: ""
        },
        data => {}
      );
    }
  },
  mounted() {
    document.querySelector(".college_detail").addEventListener(
      "touchmove",
      function(event) {
        event.preventDefault();
      },
      false
    );
  }
};
</script>
<style>
article,
.article_content {
  width: 100% !important;
  word-wrap: break-word !important;
}
.content > div {
  width: 100% !important;
  word-wrap: break-word !important;
}
.content img{
  max-width: 100% !important;
  height: 100% !important;
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
@import "index.scss";
.release {
  line-height: torem(18);
  margin-top: torem(12);
}
.college_detail {
  display: flex;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  flex-direction: column;
  width: 100vw;

  header {
    height: torem(44);
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    .van-icon {
      font-size: torem(18);
    }
  }
  .title {
    line-height: torem(24);
    font-size: torem(16);
  }
  main {
    flex: 1;
    //padding: torem(12) 0;
    box-sizing: border-box;
    overflow-y: auto;
    .commont_body {
      dl {
        dt {
          width: 100%;
          height: torem(164);
          border-radius: torem(8);
          img {
            width: 100%;
            height: 100%;
            //max-width: 100%;
            //height: torem(164);
            border-radius: torem(8);
          }
        }

        dd {
          padding: torem(16) torem(8) torem(12) torem(8);
          box-sizing: border-box;

          p {
            &:nth-child(1) {
              font-size: torem(16);
              line-height: torem(24);
              font-weight: bold;
            }

            &:nth-child(2) {
              margin-top: torem(12);
              font-size: torem(12);
              color: rgba(153, 153, 153, 1);
            }
          }
        }

        .bottom {
          width: 100%;
          padding: 0 torem(8);

          > div {
            border-bottom: 1px solid rgba(239, 239, 239, 1);
          }
        }
      }

      .content {
        max-width: 100%;
        padding: torem(16) torem(8);
        font-size: torem(14);
        line-height: torem(21);
        // white-space: pre-wrap;
        // word-wrap: break-word;
        // table-layout: fixed;
        // word-break: break-all;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/college/details.vue